module.exports = __webpack_public_path__ + "static/img/wpay.40b9955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wpay.png
// module id = atQr
// module chunks = 1